import { LoginScreenNavigationProps } from "./types"
import React from "react"
import { useTheme } from '~/ui/styled'
import Login from "./login-screen"
import { PageRoot } from "~screens/page-root"


const LoginScreen: React.FC<LoginScreenNavigationProps> = () => {
  const theme = useTheme()
  return (
    <PageRoot $background={theme.colors.primary}>
      <Login />
    </PageRoot>
  )
}

export default LoginScreen
